import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const NewspaperFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M19.8 17.44C19.8 18.84 18.76 19.84 17.34 19.84H6.9C5.48 19.84 4.44 18.84 4.44 17.44V4.08H16.52V17.38C16.52 17.86 16.88 18.2 17.34 18.2C17.8 18.2 18.16 17.84 18.16 17.38V7.04H19.8V17.44ZM7.72 7.58V9.26H13.24V7.58H7.72ZM7.72 11.12V12.8H13.24V11.12H7.72ZM7.72 14.66V16.34H11.42V14.66H7.72Z" />
    </SvgIcon>
  );
});
